import { Alert, Platform } from 'react-native';
import { confirm } from '@/components/ui/confirmation-dialog';

export function confirmDialog(
  title: string,
  message: string,
  onConfirm?: () => void,
  onCancel?: () => void,
  confirmText = 'Confirm',
) {
  confirm({
    title,
    description: message,
    variant: 'destructive',
    confirmLabel: confirmText,
  }).then((confirmed) => {
    if (confirmed) {
      onConfirm?.();
    } else {
      onCancel?.();
    }
  });
}

export function promptDialog(
  title: string,
  message: string,
  defaultValue: string,
  onSubmit: (text: string) => void,
  androidFallback?: string,
) {
  if (Platform.OS === 'web') {
    const result = window.prompt(`${title}\n${message}`, defaultValue);
    if (result !== null && result.trim().length > 0) {
      onSubmit(result.trim());
    }
  } else if (Platform.OS === 'ios') {
    Alert.prompt(
      title,
      message,
      [
        { text: 'Cancel', style: 'cancel' },
        {
          text: 'Save',
          onPress: (text?: string) => {
            if (text?.trim()) onSubmit(text.trim());
          },
        },
      ],
      'plain-text',
      defaultValue,
    );
  } else if (androidFallback) {
    Alert.alert(title, androidFallback);
  }
}
